module.exports = __webpack_public_path__ + "static/media/UniNeueRegular-Italic.06330c36.woff2";